import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from "react-redux";
import {useForm, Controller, FormProvider, useFormContext} from 'react-hook-form'
import SubmitButton from 'src/shared/form/submit_button.jsx'
import {ErrorMessage} from '@hookform/error-message';
import _ from "lodash";
import axios from "axios";
import {serialize} from "object-to-formdata";

function FormInput({name, type, title, ...rest}) {
  const {control, errors} = useFormContext();
  return (
    <div className="form-group">
      <label htmlFor={name}>{title}</label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => <input
          {...field}
          type={type}
          className="form-control"
          style={{width: "100%"}}
          {...rest}
        />}
      />
      <ErrorMessage errors={errors} name={name}
                    render={({message}) => <div className="invalid-feedback d-block">{message}</div>}/>
    </div>
  )
}

const AccountForm = ({methods, onFinished, account, setSelectedAccount, setAccounts}) => {
  const accountsUrl = useSelector(state => state.accountsUrl)
  const hostname = useSelector(state => state.hostname)

  const [sending, setSending] = useState(false)
  const [showThanks, setThanks] = useState(false)

  const sendForm = (data) => {
    setSending(true)

    axios({
      method: account ? "put" : "post",
      url: account ? `${accountsUrl}/${account.id}` : accountsUrl,
      data: serialize({account: data})
    }).then(response => {
        console.warn(response.data)
        if (response.data.status == "OK") {
          setSelectedAccount(null)
          methods.reset({
            firstname: "",
            lastname: "",
            email: "",
            password: "",
            password_confirmation: "",
          })
          setThanks(true)
          onFinished()
          setTimeout(() => setThanks(false), 3000)
        } else {
          {
            _.map(response.data.errors, (messages, field) => {
              {
                _.map(messages, (message, index) => {
                  console.log("adding error", field, message)
                  methods.setError(field, {type: "not valid", message: message})
                })
              }
            })
          }
        }
      },
      error => {
        alert(error)
        console.error(error)
        setSending(false)
      }).then(function () {
      setSending(false)
    })
  }

  return <>
    {showThanks &&
    <div className="alert alert-success">
      Account Added
    </div>
    }
    <h4>Create new account</h4>

    {(hostname === "flaveueg22" || hostname === "flaveueg23") && !account && <>
      <p>
        Here you can add users who are able to edit your company profile.
      </p>
    </>}
    <FormProvider {...methods} >
      <form onSubmit={methods.handleSubmit(sendForm)}>
        <FormInput name="firstname" title="Firstname *" type="text"/>
        <FormInput name="lastname" title="Lastname *" type="text"/>
        <FormInput name="email" title="E-Mail *" type="text"/>
        <FormInput name="password" title="Password" type="password"/>
        <FormInput name="password_confirmation" title="Password confirmation" type="password"/>
        <SubmitButton sending={sending}/>
      </form>
    </FormProvider>
  </>
}

const loadAccounts = (url, setIsLoading, setError, setAccounts) => {
  setIsLoading(true)
  setError(null)
  setAccounts([])

  axios.get(url).then(response => {
      if (response.data.status === "OK") {
        console.table(response.data.accounts)
        setError(null)
        setAccounts(response.data.accounts)
      } else {
        setError(response.data.message)
        setAccounts([])
      }
    },
    error => {
      alert(error)
      console.error(error)

      setError(response.data.message)
      setAccounts([])
    }).then(function () {
    setIsLoading(false)
  })
}


export default function Accounts() {
  const accountsUrl = useSelector(state => state.accountsUrl)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [accounts, setAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null)

  useEffect(() => {
    loadAccounts(accountsUrl, setIsLoading, setError, setAccounts)
  }, [])

  const methods = useForm({
    shouldUnregister: true,
    defaultValues: {
      firstname: selectedAccount?.firstname || "",
      lastname: selectedAccount?.lastname || "",
      email: selectedAccount?.email || "",
      password: selectedAccount?.password || "",
      password_confirmation: selectedAccount?.password_confirmation || "",
    }
  })

  if (isLoading) {
    return <div className={"text-center"}>
      <div className="spinner-border text-dark" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  } else if (error) {
    return <div className={"text-center"}>
      An error occured while loading.

      <hr/>
      {error}
      <hr/>

      <button className="btn btn-danger"
              onClick={() => loadAccounts(accountsUrl, setIsLoading, setError, setAccounts)}
      >Reload
      </button>
    </div>
  }

  return <div>
    <div className="row">
      <div className="col-md-6">
        <div className="shadow m-2 p-2">
          {selectedAccount && <>
            You currently have {selectedAccount.name} selected.
            <button className="btn btn-danger float-right" onClick={() => {
              setSelectedAccount(null)
              methods.reset({
                firstname: "",
                lastname: "",
                email: "",
                password: "",
                password_confirmation: "",
              })
            }}>
              Unselect{" "}
              <i className="fa fa-times" aria-hidden="true"/>
            </button>
            <hr/>
          </>}

          <AccountForm methods={methods}
                       account={selectedAccount}
                       setAccounts={setAccounts}
                       setSelectedAccount={setSelectedAccount}
                       onFinished={() => loadAccounts(accountsUrl, setIsLoading, setError, setAccounts)}/>
        </div>
      </div>
      <div className="col-md-6">
        <div className="shadow m-2 p-2">
          {accounts.length > 0 ? <>
            <h4>{accounts.length} Accounts</h4>
            <hr/>
            {accounts.map(account => {
              return <div key={account.id} className={"row"}>
                <div className="col-8">
                  {account.name}
                  <br/>
                  {account.email}
                </div>
                <div className="col-4 text-right">
                  <button className="btn fa-btn" onClick={() => {
                    setSelectedAccount(account)
                    methods.reset({
                      firstname: account?.firstname || "",
                      lastname: account?.lastname || "",
                      email: account?.email || "",
                      password: account?.password || "",
                      password_confirmation: account?.password_confirmation || "",
                    })
                  }}>
                    <i className="fa fa-edit"/>
                  </button>
                </div>
                <div className="col-12">
                  <hr/>
                </div>

              </div>
            })}
          </> : <>
            <div className="row">
              <div className="col-12">
                Currently you have no accounts added.
              </div>
            </div>
          </>}
        </div>
      </div>
    </div>
  </div>;
}
